/* Hortelã 2.0 · tabela de medidas da página de produto
   - Medidas do corpo: ABNT NBR 16933 (biótipo retângulo, o mais comum entre as brasileiras), em cm.
   - Dados da peça em [data-h2-medidas] (snippets/h2-medidas.liquid); abre por qualquer [data-h2-medidas-abrir].
   - Guarda o número que a cliente usa (localStorage "h2-numero") e mostra em todas as peças se serve.
   - Eventos pra análise: Shopify.analytics.publish('h2_tabela_medidas', {acao, produto, numero, serve}). */
(function () {
  if (window.H2Medidas) return;

  /* número: [letra, busto, cintura, quadril, coxa] */
  var ABNT = {
    34: ['PP', 80, 66, 86, 51], 36: ['P', 84, 70, 90, 53.5], 38: ['P', 88, 74, 94, 56],
    40: ['M', 92, 78, 98, 58.5], 42: ['M', 96, 82, 102, 61], 44: ['G', 100, 86, 106, 63.5],
    46: ['G', 104, 90, 110, 66], 48: ['GG', 108, 94, 114, 68.5], 50: ['GG', 112, 98, 118, 71],
    52: ['G2', 118, 104, 124, 74.5], 54: ['G2', 124, 110, 130, 78], 56: ['G3', 130, 116, 136, 81.5],
    58: ['G3', 136, 122, 142, 85], 60: ['G4', 142, 128, 148, 88.5], 62: ['G4', 148, 134, 154, 92]
  };
  var NUMEROS = [34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62];
  var NA_FITA = [34, 36, 38, 40, 42, 44, 46, 48, 50, 52];
  var COL = { busto: 1, cintura: 2, quadril: 3, coxa: 4 };
  var NOME = { busto: 'Busto', cintura: 'Cintura', quadril: 'Quadril', coxa: 'Coxa', comprimento: 'Comprimento' };
  var LETRAS = ['PP', 'P', 'M', 'G', 'GG'];
  var DA_LETRA = { PP: [34], P: [36, 38], M: [40, 42], G: [44, 46], GG: [48, 50] };
  var MODELAGEM = {
    ampla: 'Modelagem ampla, com caimento solto.',
    ajustada: 'Modelagem ajustada, veste rente ao corpo.',
    reta: 'Modelagem reta, nem justa nem solta.',
    acinturada: 'Modelagem acinturada, marca a cintura.'
  };
  var ELASTICO = { grande: 'O tricot estica bastante.', medio: 'O tricot estica um pouco.', 'médio': 'O tricot estica um pouco.', media: 'O tricot estica um pouco.', 'média': 'O tricot estica um pouco.', pequena: 'O tricot estica pouco.', baixa: 'O tricot estica pouco.' };
  var CHAVE = 'h2-numero';
  var ZAP = (window.H2_SHOPPER && window.H2_SHOPPER.zap) || '5512996251858';
  var CHECK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5 9-10"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function cm(v) { return String(v).replace('.', ','); }
  function lerNumero() {
    try { var n = parseInt(window.localStorage.getItem(CHAVE), 10); return ABNT[n] ? n : 0; } catch (e) { return 0; }
  }
  function salvarNumero(n) { try { window.localStorage.setItem(CHAVE, String(n)); } catch (e) { /* sem armazenamento: segue sem lembrar */ } }
  function evento(acao, extra) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        var d = { acao: acao };
        for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) d[k] = extra[k];
        window.Shopify.analytics.publish('h2_tabela_medidas', d);
      }
    } catch (e) { /* análise é opcional */ }
  }

  function dados(el) {
    var peca = [];
    (el.getAttribute('data-peca') || '').split(';').forEach(function (par) {
      var p = par.split(':');
      if (p.length === 2 && p[1]) peca.push([p[0], p[1]]);
    });
    return {
      el: el,
      modo: el.getAttribute('data-modo'),
      ini: parseInt(el.getAttribute('data-ini'), 10) || 0,
      fim: parseInt(el.getAttribute('data-fim'), 10) || 0,
      tamanhos: (el.getAttribute('data-tamanhos') || '').split(',').filter(function (x) { return LETRAS.indexOf(x) > -1; })
        .sort(function (a, b) { return LETRAS.indexOf(a) - LETRAS.indexOf(b); }),
      colunas: (el.getAttribute('data-colunas') || 'busto,cintura,quadril').split(',').filter(function (c) { return COL[c]; }),
      modelagem: (el.getAttribute('data-modelagem') || '').toLowerCase(),
      elasticidade: (el.getAttribute('data-elasticidade') || '').toLowerCase(),
      peca: peca,
      produto: el.getAttribute('data-produto') || ''
    };
  }

  /* serve? {ok, abaixo, acima, letra, limite} */
  function avaliar(d, n) {
    if (!n || !ABNT[n]) return null;
    if (d.modo === 'letra') {
      var letra = ABNT[n][0];
      if (d.tamanhos.indexOf(letra) > -1) return { ok: true, letra: letra };
      var min = d.tamanhos[0], max = d.tamanhos[d.tamanhos.length - 1];
      var pos = LETRAS.indexOf(letra);
      if (pos === -1 || pos > LETRAS.indexOf(max)) return { ok: false, acima: true, letra: letra, limite: max };
      return { ok: false, abaixo: true, letra: letra, limite: min };
    }
    if (n < d.ini) return { ok: false, abaixo: true };
    if (n > d.fim) return { ok: false, acima: true };
    return { ok: true, borda: n === d.ini ? 'inicio' : (n === d.fim ? 'fim' : '') };
  }

  /* ---------- barra da página (status com o número guardado) ---------- */
  function atualizarBarra(el) {
    var st = el.querySelector('[data-h2-medidas-status]');
    if (!st) return;
    var d = dados(el), n = lerNumero(), r = avaliar(d, n);
    st.classList.remove('is-serve', 'is-atencao');
    if (!r) {
      st.textContent = d.modo === 'letra' ? 'Descubra o seu tamanho' : 'Ver tabela de medidas';
      return;
    }
    if (r.ok) {
      st.classList.add('is-serve');
      st.innerHTML = CHECK + '<span>' + (d.modo === 'letra' ? 'No seu ' + n + ', é o ' + r.letra : 'Serve no seu ' + n) + '</span><span class="h2-medidas__ver">ver medidas</span>';
    } else {
      st.classList.add('is-atencao');
      var lim = d.modo === 'letra' ? r.limite : (r.acima ? d.fim : d.ini);
      st.innerHTML = '<span>' + (r.acima ? 'Vai até o ' : 'Começa no ') + lim + '</span><span class="h2-medidas__ver">ver medidas</span>';
    }
  }
  function atualizarBarras() { document.querySelectorAll('[data-h2-medidas]').forEach(atualizarBarra); }

  /* ---------- janela ---------- */
  var raiz = null, atual = null, quemAbriu = null, aberta = false, comHistorico = false, timerFechar = null, depoisDeFechar = null;
  var digitadas = { busto: '', cintura: '', quadril: '' };

  function montar() {
    if (raiz) return raiz;
    raiz = document.createElement('div');
    raiz.className = 'h2med h2';
    raiz.setAttribute('role', 'dialog');
    raiz.setAttribute('aria-modal', 'true');
    raiz.setAttribute('aria-labelledby', 'h2med-titulo');
    raiz.hidden = true;
    raiz.innerHTML = '<div class="h2med__fundo" data-h2med-fechar></div>' +
      '<div class="h2med__caixa" tabindex="-1">' +
      '<div class="h2med__topo"><div><p class="h2med__titulo" id="h2med-titulo">Tabela de medidas</p><p class="h2med__produto" data-h2med-produto></p></div>' +
      '<button type="button" class="h2med__fechar" data-h2med-fechar aria-label="Fechar a tabela de medidas"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<div class="h2med__corpo" data-h2med-corpo></div></div>';
    document.body.appendChild(raiz);
    raiz.addEventListener('click', aoClicar);
    raiz.addEventListener('submit', aoEnviar);
    document.addEventListener('keydown', function (e) {
      if (!aberta) return;
      if (e.key === 'Escape') fechar();
      if (e.key === 'Tab') prenderFoco(e);
    });
    window.addEventListener('popstate', function () {
      if (!comHistorico) return;
      comHistorico = false;
      if (aberta) fechar(true);
      if (depoisDeFechar) { var f = depoisDeFechar; depoisDeFechar = null; setTimeout(f, 30); }
    });
    return raiz;
  }
  function prenderFoco(e) {
    var f = raiz.querySelectorAll('button:not([disabled]), a[href], input, summary, [tabindex="0"]');
    if (!f.length) return;
    var primeiro = f[0], ultimo = f[f.length - 1];
    if (e.shiftKey && document.activeElement === primeiro) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primeiro.focus(); }
  }
  function abrir(el, botao) {
    montar();
    atual = dados(el);
    quemAbriu = botao || document.activeElement;
    raiz.querySelector('[data-h2med-produto]').textContent = atual.produto;
    desenhar(lerNumero(), false);
    if (timerFechar) { clearTimeout(timerFechar); timerFechar = null; }
    raiz.hidden = false;
    void raiz.offsetWidth; /* aplica o estado inicial antes da transição */
    raiz.classList.add('is-aberta');
    document.documentElement.classList.add('h2med-aberta');
    aberta = true;
    if (!comHistorico) {
      try { window.history.pushState({ h2med: 1 }, ''); comHistorico = true; } catch (e) { comHistorico = false; }
    }
    var caixa = raiz.querySelector('.h2med__caixa');
    caixa.scrollTop = 0;
    setTimeout(function () { caixa.focus(); centralizarFita(); }, 40);
    evento('abrir', { produto: atual.produto, numero: lerNumero() || null });
  }
  function fechar(peloVoltar) {
    if (!raiz || !aberta) return;
    aberta = false;
    raiz.classList.remove('is-aberta');
    document.documentElement.classList.remove('h2med-aberta');
    timerFechar = setTimeout(function () { raiz.hidden = true; timerFechar = null; }, 240);
    if (comHistorico && !peloVoltar) {
      try { window.history.back(); } catch (e) { comHistorico = false; }
    }
    atualizarBarras();
    if (quemAbriu && quemAbriu.focus) { try { quemAbriu.focus({ preventScroll: true }); } catch (e) { quemAbriu.focus(); } }
    if (!comHistorico && depoisDeFechar) { var f = depoisDeFechar; depoisDeFechar = null; setTimeout(f, 30); }
  }

  /* ---------- conteúdo ---------- */
  function fita(d, n) {
    var html = '';
    NA_FITA.forEach(function (num, i) {
      var cabe;
      if (d.modo === 'letra') cabe = d.tamanhos.indexOf(ABNT[num][0]) > -1;
      else cabe = num >= d.ini && num <= d.fim;
      var antes = i > 0 && (d.modo === 'letra' ? d.tamanhos.indexOf(ABNT[NA_FITA[i - 1]][0]) > -1 : NA_FITA[i - 1] >= d.ini && NA_FITA[i - 1] <= d.fim);
      var depois = i < NA_FITA.length - 1 && (d.modo === 'letra' ? d.tamanhos.indexOf(ABNT[NA_FITA[i + 1]][0]) > -1 : NA_FITA[i + 1] >= d.ini && NA_FITA[i + 1] <= d.fim);
      var cls = 'h2med__num' + (cabe ? ' is-cabe' : '') + (cabe && !antes ? ' is-cabe-ini' : '') + (cabe && !depois ? ' is-cabe-fim' : '') + (num === n ? ' is-ativo' : '');
      var rotulo = num === 52 ? '52+' : String(num);
      html += '<button type="button" class="' + cls + '" data-h2med-num="' + num + '" aria-pressed="' + (num === n) + '" aria-label="Uso ' + num + (num === 52 ? ' ou mais' : '') + '">' +
        '<span class="h2med__traco" aria-hidden="true"></span><span class="h2med__num-n">' + rotulo + '</span><span class="h2med__num-l" aria-hidden="true">' + ABNT[num][0] + '</span></button>';
    });
    return html;
  }
  function resposta(d, n) {
    var r = avaliar(d, n);
    if (!r) return { cls: '', html: '' };
    var zap = ' <a class="h2med__link" href="' + linkZap(d, n) + '" target="_blank" rel="noopener">Chamar no WhatsApp</a>';
    if (d.modo === 'letra') {
      if (r.ok) {
        var inp = acharTamanho(r.letra), b = '';
        if (inp && !inp.classList.contains('option-disabled')) {
          b = ' <button type="button" class="h2med__escolher" data-h2med-escolher="' + r.letra + '">Escolher o ' + r.letra + '</button>';
        } else {
          var disp = disponivel(r.letra);
          if (disp && !disp.naCor) b = ' Nessa cor ele acabou' + (disp.outras.length ? ', mas tem ' + (disp.outras.length > 1 ? 'nas cores ' : 'na cor ') + juntar(disp.outras) : '') + '.';
        }
        return { cls: 'is-sim', html: CHECK + '<p>No seu ' + n + ', o tamanho certo é o <strong>' + r.letra + '</strong>.' + b + '</p>' };
      }
      if (r.acima) return { cls: 'is-nao', html: '<p>O maior tamanho dessa peça é o ' + r.limite + '. Chama a vendedora que ela te indica uma parecida no seu número.' + zap + '</p>' };
      return { cls: 'is-nao', html: '<p>O menor tamanho dessa peça é o ' + r.limite + '. No seu ' + n + ', ele fica mais soltinho.</p>' };
    }
    if (r.ok) {
      var extra = 'Essa peça veste do ' + d.ini + ' ao ' + d.fim + '.';
      if (r.borda === 'inicio') extra = 'No ' + n + ' ela fica mais soltinha.';
      if (r.borda === 'fim') extra = 'No ' + n + ' ela fica mais justinha.';
      return { cls: 'is-sim', html: CHECK + '<p><strong>Serve em você!</strong> ' + extra + '</p>' };
    }
    if (r.acima) return { cls: 'is-nao', html: '<p>Essa peça vai até o ' + d.fim + ', então no seu ' + (n === 52 ? '52 ou mais' : n) + ' ela pode ficar apertada. Chama a vendedora que ela te indica uma parecida no seu número.' + zap + '</p>' };
    return { cls: 'is-nao', html: '<p>Essa peça começa no ' + d.ini + '. No seu ' + n + ', ela fica bem soltinha.</p>' };
  }
  /* A tabela é do corpo de quem usa cada número (não da roupa): a 1ª coluna diz "Você usa" */
  function tabela(d, n) {
    var cols = d.colunas;
    var cab = d.modo === 'letra' ? '<th scope="col">Tamanho</th><th scope="col">Você usa</th>' : '<th scope="col">Você usa</th>';
    cols.forEach(function (c) { cab += '<th scope="col">' + NOME[c] + '</th>'; });
    var linhas = '';
    if (d.modo === 'letra') {
      var letraSua = n && ABNT[n] ? ABNT[n][0] : '';
      d.tamanhos.forEach(function (L) {
        var nums = DA_LETRA[L];
        var tds = '<th scope="row">' + L + '</th><td>' + nums.join(' ou ') + '</td>';
        cols.forEach(function (c) {
          var a = ABNT[nums[0]][COL[c]], b = ABNT[nums[nums.length - 1]][COL[c]];
          tds += '<td>' + (a === b ? cm(a) : cm(a) + ' a ' + cm(b)) + '</td>';
        });
        linhas += '<tr' + (L === letraSua ? ' class="is-sua"' : '') + '>' + tds + '</tr>';
      });
    } else {
      for (var num = d.ini; num <= d.fim; num += 2) {
        if (!ABNT[num]) continue;
        var tds2 = '<th scope="row">' + num + ' <span class="h2med__letra">(' + ABNT[num][0] + ')</span></th>';
        cols.forEach(function (c) { tds2 += '<td>' + cm(ABNT[num][COL[c]]) + '</td>'; });
        linhas += '<tr' + (num === n ? ' class="is-sua"' : '') + '>' + tds2 + '</tr>';
      }
    }
    return '<table class="h2med__tabela"><caption class="h2med__sr">Medidas do corpo de quem usa cada número, em centímetros</caption><thead><tr>' + cab + '</tr></thead><tbody>' + linhas + '</tbody></table>';
  }
  /* "busto de 84 a 100 cm e cintura de 70 a 86 cm": o corpo que a peça veste, do menor ao maior número */
  function faixaCorpo(d) {
    var a, b;
    if (d.modo === 'letra') {
      if (!d.tamanhos.length) return '';
      a = DA_LETRA[d.tamanhos[0]][0];
      var ult = DA_LETRA[d.tamanhos[d.tamanhos.length - 1]];
      b = ult[ult.length - 1];
    } else {
      a = d.ini;
      b = d.fim;
    }
    if (!ABNT[a] || !ABNT[b]) return '';
    return juntar(d.colunas.map(function (c) { return NOME[c].toLowerCase() + ' de ' + cm(ABNT[a][COL[c]]) + ' a ' + cm(ABNT[b][COL[c]]) + ' cm'; }));
  }
  function boneco(comCoxa) {
    var arco = function (y, rx) { return 'M' + (80 - rx) + ' ' + y + ' A' + rx + ' 5.5 0 0 0 ' + (80 + rx) + ' ' + y; };
    var marca = function (y, x, num) {
      return '<path class="m-linha" d="M' + x + ' ' + y + 'H142"/><circle class="m-bola" cx="150" cy="' + y + '" r="8.5"/><text class="m-num" x="150" y="' + (y + 3.8) + '" text-anchor="middle">' + num + '</text>';
    };
    return '<svg class="h2med__boneco" viewBox="0 0 168 250" width="168" height="250" aria-hidden="true">' +
      '<path class="b-corpo" d="M88 30C96 36 112 38 122 44C128 47 129 54 125 60C121 66 119 72 121 80C124 88 125 96 121 104C117 112 108 118 108 126C108 136 112 142 117 150C122 158 125 164 124 172C123 182 118 190 108 193Q80 198 52 193C42 190 37 182 36 172C35 164 38 158 43 150C48 142 52 136 52 126C52 118 43 112 39 104C35 96 36 88 39 80C41 72 39 66 35 60C31 54 32 47 38 44C48 38 64 36 72 30Z"/>' +
      '<rect class="b-corpo" x="72" y="12" width="16" height="19" rx="3"/>' +
      '<path class="b-pe" d="M80 196V232M80 232L62 243M80 232L98 243M80 232V245"/>' +
      '<g class="b-fita">' +
      '<path d="' + arco(96, 46) + '"/><path d="' + arco(126, 30) + '"/><path d="' + arco(170, 46) + '"/>' +
      (comCoxa ? '<path d="' + arco(188, 34) + '"/>' : '') + '</g>' +
      marca(96, 128, 1) + marca(126, 112, 2) + marca(170, 128, 3) + (comCoxa ? marca(188, 116, 4) : '') +
      '</svg>';
  }
  function linkZap(d, n) {
    var msg = 'Oi! Estou vendo a peça ' + d.produto + ' no site e queria saber se ela serve em mim.' + (n ? ' Eu uso ' + (n === 52 ? '52 ou mais' : n) + '.' : '');
    return 'https://wa.me/' + ZAP + '?text=' + encodeURIComponent(msg);
  }

  function desenhar(n, manterRolagem) {
    var d = atual;
    var corpo = raiz.querySelector('[data-h2med-corpo]');
    var calcAntes = raiz.querySelector('.h2med__calc');
    var calcAberta = !!(manterRolagem && calcAntes && calcAntes.open);
    var resp = resposta(d, n);
    var letra = d.modo === 'letra';
    var notas = [];
    if (!letra) notas.push(d.elasticidade && ELASTICO[d.elasticidade] ? ELASTICO[d.elasticidade] : 'O tricot estica e se ajusta ao corpo.');
    else if (d.elasticidade && ELASTICO[d.elasticidade]) notas.push(ELASTICO[d.elasticidade]);
    if (d.modelagem) notas.push(MODELAGEM[d.modelagem] || ('Modelagem ' + esc(d.modelagem) + '.'));
    var temCoxa = d.colunas.indexOf('coxa') > -1;
    var serveEm = faixaCorpo(d);
    var html = '';
    /* 1. O que é a peça: tamanho único (sem P, M ou G pra escolher) ou com tamanhos */
    if (letra) {
      html += '<div class="h2med__resumo"><p class="h2med__faixa">Tamanhos ' + juntar(d.tamanhos) + '</p>' +
        '<p class="h2med__notas">Toque no número que você usa que a gente te diz qual tamanho escolher.' + (notas.length ? ' ' + notas.join(' ') : '') + '</p></div>';
    } else {
      html += '<div class="h2med__resumo"><p class="h2med__faixa">Tamanho único</p>' +
        '<p class="h2med__notas"><strong>É uma peça só, sem P, M ou G pra escolher.</strong> Ela veste quem usa do ' + d.ini + ' ao ' + d.fim + '. ' + notas.join(' ') + '</p></div>';
    }
    /* 2. Serve em você? (toque no número) */
    html += '<section class="h2med__bloco" aria-labelledby="h2med-pergunta"><h3 class="h2med__h3" id="h2med-pergunta">' + (letra ? 'Qual tamanho é o seu?' : 'Serve em você?') + '</h3>' +
      '<p class="h2med__sub">Toque no número que você costuma usar:</p>' +
      '<div class="h2med__fita" data-h2med-fita role="group" aria-labelledby="h2med-pergunta">' + fita(d, n) + '</div>' +
      '<p class="h2med__legenda"><span class="h2med__legenda-cor" aria-hidden="true"></span>' + (letra ? 'Números que essa peça atende' : 'Números que essa peça veste') + '</p>' +
      '<div class="h2med__resposta ' + resp.cls + '" data-h2med-resposta aria-live="polite">' + resp.html + '</div></section>';
    /* 3. Não sabe o número: mede o corpo e acha a linha na tabela (ou deixa a conta com a gente) */
    html += '<section class="h2med__bloco h2med__descobrir" aria-labelledby="h2med-descobrir"><h3 class="h2med__h3" id="h2med-descobrir">Não sabe o seu número?</h3>' +
      '<p class="h2med__sub">Com uma fita métrica você descobre em 1 minuto.</p>' +
      '<div class="h2med__passo"><p class="h2med__passo-t"><span class="h2med__passo-n">Passo 1</span>Meça o seu corpo</p>' +
      '<div class="h2med__como-grade">' + boneco(temCoxa) +
      '<ol class="h2med__passos"><li><strong>Busto</strong> Passe a fita em volta da parte mais cheia do busto.</li>' +
      '<li><strong>Cintura</strong> Na parte mais fina da cintura, um pouco acima do umbigo.</li>' +
      '<li><strong>Quadril</strong> Na parte mais larga do quadril, com os pés juntos.</li>' +
      (temCoxa ? '<li><strong>Coxa</strong> Na parte mais grossa da coxa, logo abaixo do bumbum.</li>' : '') +
      '</ol></div><p class="h2med__dica">Use a fita sem apertar, por cima de uma roupa fininha.</p></div>' +
      '<div class="h2med__passo"><p class="h2med__passo-t"><span class="h2med__passo-n">Passo 2</span>Ache a sua linha na tabela</p>' +
      '<p class="h2med__aviso">Essas são as medidas do <strong>corpo</strong> de quem usa cada número, em centímetros. Não são as medidas da roupa.</p>' +
      tabela(d, n) +
      (serveEm ? '<p class="h2med__serve-em">' + (letra ? 'Os tamanhos dessa peça vestem quem tem ' : 'Essa peça serve em quem tem ') + serveEm + '.</p>' : '') +
      '</div>' +
      '<details class="h2med__calc"' + (calcAberta ? ' open' : '') + '><summary>Prefere que a gente calcule? Coloque suas medidas</summary>' +
      '<form class="h2med__form" data-h2med-form novalidate><div class="h2med__campos">' +
      ['busto', 'cintura', 'quadril'].map(function (c) {
        return '<label class="h2med__campo"><span>' + NOME[c] + '</span><span class="h2med__entrada"><input type="number" inputmode="decimal" min="50" max="190" step="0.5" name="' + c + '" value="' + esc(digitadas[c]) + '" autocomplete="off"><em>cm</em></span></label>';
      }).join('') +
      '</div><button type="submit" class="h2med__btn">Descobrir meu número</button><p class="h2med__calc-msg" data-h2med-calc-msg aria-live="polite"></p></form></details></section>';
    /* 4. Medidas da roupa (quando a peça tem): separadas e com o nome certo */
    if (d.peca.length) {
      html += '<section class="h2med__bloco" aria-labelledby="h2med-peca"><h3 class="h2med__h3" id="h2med-peca">Medidas da roupa <span>sem esticar</span></h3><ul class="h2med__peca">' +
        d.peca.map(function (p) { return '<li><span>' + (NOME[p[0]] || esc(p[0])) + '</span><strong>' + esc(p[1]) + ' cm</strong></li>'; }).join('') + '</ul></section>';
    }
    html += '<div class="h2med__ajuda"><p>Ficou em dúvida? A vendedora te ajuda a escolher.</p><a class="h2med__zap" href="' + linkZap(d, n) + '" target="_blank" rel="noopener" data-h2med-zap>' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2Zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7 11.8 11.8 0 0 0 4.5 4c1.7.7 2.3.8 3.1.7.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.2-.2-.4-.3Z"/></svg>Chamar no WhatsApp</a></div>';
    html += '<p class="h2med__fonte">Medidas do corpo pela norma ABNT NBR 16933, biótipo retângulo, o mais comum entre as brasileiras.</p>';
    corpo.innerHTML = html;
  }
  function centralizarFita() {
    var f = raiz && raiz.querySelector('[data-h2med-fita]');
    if (!f || f.scrollWidth <= f.clientWidth) return;
    var alvo = f.querySelector('.is-ativo') || f.querySelector('.is-cabe');
    if (alvo) f.scrollLeft = Math.max(0, alvo.offsetLeft - f.clientWidth / 2 + alvo.offsetWidth / 2);
  }

  function escolherNumero(n, origem) {
    salvarNumero(n);
    var caixa = raiz.querySelector('.h2med__caixa');
    var topo = caixa.scrollTop;
    desenhar(n, true);
    caixa.scrollTop = topo;
    var r = avaliar(atual, n);
    var botao = raiz.querySelector('[data-h2med-num="' + n + '"]');
    if (botao && origem === 'fita') botao.focus();
    atualizarBarras();
    evento(origem === 'calculadora' ? 'calculou' : 'numero', { produto: atual.produto, numero: n, serve: !!(r && r.ok) });
  }

  /* tamanho por medida: o menor número que comporta a medida (1 cm de folga) */
  function numeroPorMedida(col, valor) {
    for (var i = 0; i < NUMEROS.length; i++) if (ABNT[NUMEROS[i]][col] >= valor - 1) return NUMEROS[i];
    return 62;
  }
  function aoEnviar(e) {
    var form = e.target.closest('[data-h2med-form]');
    if (!form) return;
    e.preventDefault();
    var ler = function (nome) { var v = parseFloat(String(form.elements[nome].value).replace(',', '.')); return isFinite(v) ? v : 0; };
    var b = ler('busto'), c = ler('cintura'), q = ler('quadril');
    digitadas = { busto: form.elements.busto.value, cintura: form.elements.cintura.value, quadril: form.elements.quadril.value };
    var msg = form.querySelector('[data-h2med-calc-msg]');
    var fora = (b && (b < 60 || b > 180)) || (c && (c < 45 || c > 170)) || (q && (q < 65 || q > 190));
    if ((!b && !c && !q) || fora) {
      msg.textContent = fora ? 'Confere a medida? Coloque em centímetros, por exemplo 92.' : 'Coloque pelo menos o busto ou o quadril.';
      return;
    }
    var cand = [];
    if (b) cand.push(numeroPorMedida(1, b));
    if (q) cand.push(numeroPorMedida(3, q));
    if (!cand.length && c) cand.push(numeroPorMedida(2, c));
    var n = Math.max.apply(null, cand);
    var naFita = n > 52 ? 52 : n;
    escolherNumero(naFita, 'calculadora');
    var r = avaliar(atual, naFita);
    var veredito = '';
    if (r && r.ok) veredito = atual.modo === 'letra' ? ' Nessa peça, o seu tamanho é o ' + r.letra + '.' : ' Essa peça serve em você!';
    else if (r && r.acima) veredito = atual.modo === 'letra' ? ' O maior tamanho dessa peça é o ' + r.limite + '.' : ' Essa peça vai até o ' + atual.fim + '.';
    else if (r && r.abaixo) veredito = atual.modo === 'letra' ? ' O menor tamanho dessa peça é o ' + r.limite + '.' : ' Essa peça começa no ' + atual.ini + ', fica bem soltinha em você.';
    var novo = raiz.querySelector('[data-h2med-calc-msg]');
    if (novo) novo.innerHTML = 'Pelas suas medidas, seu número é o <strong>' + n + '</strong>.' + veredito;
  }

  /* tamanho com letra: aciona o botão do seletor do tema */
  function seletor() { return document.querySelector('.product-detail__variant-picker') || document; }
  function acharTamanho(letra) {
    var inputs = seletor().querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      if (String(inp.value || '').trim().toUpperCase() !== letra || inp.closest('.h2med')) continue;
      var grupo = inp.closest('fieldset') || inp.parentElement;
      var texto = (inp.name || '') + ' ' + (grupo ? grupo.textContent : '');
      if (/tamanho|size/i.test(texto)) return inp;
    }
    return null;
  }
  /* o tamanho tem na cor escolhida? e em quais outras cores? (lê as variantes que o tema já põe na página) */
  function disponivel(letra) {
    var s = seletor().querySelector('script[type="application/json"]'), vs;
    try { vs = s ? JSON.parse(s.textContent) : null; } catch (e) { vs = null; }
    if (!vs || !vs.length || !vs[0].options || vs[0].options.length !== 2) return null;
    var iT = -1;
    vs.forEach(function (v) { v.options.forEach(function (o, i) { if (String(o).trim().toUpperCase() === letra) iT = i; }); });
    if (iT < 0) return null;
    var iC = iT === 0 ? 1 : 0, campos = seletor().querySelectorAll('fieldset'), cor = null;
    if (campos[iC]) { var marcado = campos[iC].querySelector('input[type="radio"]:checked'); if (marcado) cor = marcado.value; }
    if (cor === null) return null;
    var naCor = false, outras = [];
    vs.forEach(function (v) {
      if (!v.available || String(v.options[iT]).trim().toUpperCase() !== letra) return;
      if (v.options[iC] === cor) naCor = true;
      else if (outras.indexOf(v.options[iC]) < 0) outras.push(v.options[iC]);
    });
    return { naCor: naCor, outras: outras };
  }
  function juntar(lista) {
    return lista.length < 2 ? lista.join('') : lista.slice(0, -1).join(', ') + ' e ' + lista[lista.length - 1];
  }
  function escolherTamanho(letra) {
    var inp = acharTamanho(letra);
    if (!inp) return;
    var rotulo = inp.id ? document.querySelector('label[for="' + inp.id + '"]') : null;
    (rotulo || inp).click();
  }

  function aoClicar(e) {
    var t = e.target;
    if (t.closest('[data-h2med-fechar]')) { fechar(); return; }
    var b = t.closest('[data-h2med-num]');
    if (b) { escolherNumero(parseInt(b.getAttribute('data-h2med-num'), 10), 'fita'); return; }
    var esc2 = t.closest('[data-h2med-escolher]');
    if (esc2) {
      var letra = esc2.getAttribute('data-h2med-escolher');
      evento('escolheu_tamanho', { produto: atual.produto, letra: letra });
      depoisDeFechar = function () { escolherTamanho(letra); };
      fechar();
      return;
    }
    if (t.closest('[data-h2med-zap], .h2med__link')) evento('whatsapp', { produto: atual.produto, numero: lerNumero() || null });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-h2-medidas-abrir]');
    if (!b) return;
    var el = b.closest('[data-h2-medidas]') || document.querySelector('[data-h2-medidas]');
    if (!el) return;
    e.preventDefault();
    abrir(el, b);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', atualizarBarras); else atualizarBarras();
  window.addEventListener('storage', function (e) { if (e.key === CHAVE) atualizarBarras(); });
  window.H2Medidas = { abrir: function () { var el = document.querySelector('[data-h2-medidas]'); if (el) abrir(el); }, atualizar: atualizarBarras };
})();
